
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_me4cz_94",
  "checkbox-control": "awsui_checkbox-control_k2y2q_me4cz_106",
  "outline": "awsui_outline_k2y2q_me4cz_114"
};
  